module.exports = __webpack_public_path__ + "img/letterEBanner.2c317fd2.png";